import { render } from "./CustomerDashboard.vue?vue&type=template&id=4a0d9e37"
import script from "./CustomerDashboard.vue?vue&type=script&lang=js"
export * from "./CustomerDashboard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__